import { useEffect, useState } from "react";
import { Button, ButtonGroup, Grid } from "@mui/material";
import Templete from "../../template/Template";
import Calendar from "./Tabs/Calendar";
import dayjs, { Dayjs } from "dayjs";
import ListEvents from "./Tabs/ListEvents";
import { Appointment, NewAppointment } from "../../types/agendamentos";
import ModalAgendamento from "./Tabs/ModalAgendamentos";
import { isPermite } from "../../utilities/isPermite";
import { AlertConfirm, AlertInfo } from "../../components/Alerts/Alert";
import SimpleBackdrop from "../../components/Loading/SimpleBackdrop";
import { api } from "../../services/api";
import { endMes, formatDate, startMes } from "../../utilities/date";

export default function Agendamentos() {
    const [openLoad, setOpenLoad] = useState(false);
    const [menuActive, setMenuActive] = useState("0");
    const [rows, setRows] = useState([]);
    const [selectedDate, setSelectedDate] = useState<Dayjs>(dayjs());
    const [selectMes, setSelectMes] = useState('');
    const [appointments, setAppointments] = useState<Appointment[]>([]);
    const [datesWithAppointments, setDatesWithAppointments] = useState<Set<string | null>>(new Set());
    const [filteredAppointments, setFilteredAppointments] = useState<Appointment[]>([]);
    const [editingAppointment, setEditingAppointment] = useState<Appointment | null>(null);
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleSaveAppointment = async (newAppointment: NewAppointment) => {
        if (openLoad) return;
        setOpenLoad(true);
        try {
            const urlChannel = editingAppointment ? `/updateagendamento/${editingAppointment.id_agendamento}` : `/createagendamento`;
            const response = await api.post(urlChannel, newAppointment);
            if (response.data.success) {
                AlertInfo({ icon: 'success', title: 'Dados Gravados' });
                setEditingAppointment(null);
            } else if (response.data.error) {
                AlertInfo({ icon: 'error', title: response.data.message });
            }
            loadData();
            setOpenLoad(false);
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha na conexão' });
            setOpenLoad(false);
        }
    };

    const handleDeleteAppointment = async (id: string) => {
        if (isPermite("83")) {
            AlertConfirm({ title: 'DELETAR AGENDAMENTO?' }).then(async res => {
                if (res.isConfirmed) {
                    setOpenLoad(true);
                    try {
                        const response = await api.post(`/updateagendamento/${id}`, { agendamento_ativo: 0 });
                        if (response.data.success) {
                            AlertInfo({ icon: 'success', title: 'Dados Gravados' });
                            setEditingAppointment(null);
                        } else if (response.data.error) {
                            AlertInfo({ icon: 'error', title: response.data.message });
                        }
                        loadData();
                        setOpenLoad(false);
                    } catch (error) {
                        console.log(error);
                        AlertInfo({ icon: 'error', title: 'Falha na conexão' });
                        setOpenLoad(false);
                    }
                }
            });
        } else {
            AlertInfo({ icon: 'error', title: 'Usuario sem Permissão' });
        }
    };

    function onAddAppointment() {
        if (isPermite("81")) {
            setEditingAppointment(null);
            setDialogOpen(true);
        } else {
            AlertInfo({ icon: 'error', title: 'Usuario sem Permissão' });
        }
    }

    function onEditAppointment(appointment: Appointment) {
        if (isPermite("82")) {
            setEditingAppointment(appointment);
            setDialogOpen(true);
        } else {
            AlertInfo({ icon: 'error', title: 'Usuario sem Permissão' });
        }
    }

    async function loadData() {
        if (openLoad) return;
        setOpenLoad(true);
        try {
            const start = formatDate(startMes(selectMes), 'usd');
            const end = formatDate(endMes(selectMes), 'usd');
            const response = await api.get(`/agendamentosmes/${start}/${end}`);
            console.log(response);
            if (response.data && !response.data.error) {
                setAppointments(response.data);
            }
            setOpenLoad(false);
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha na conexão' });
            setOpenLoad(false);
        }
    }

    useEffect(() => {
        const filtered = appointments.filter(
            (apt) => dayjs(apt.data_agendamento).format("YYYY-MM-DD") === selectedDate.format('YYYY-MM-DD')
        );
        // console.log(fil)
        setFilteredAppointments(filtered.sort((a, b) => {
            if (!a.hora_inicio && !b.hora_inicio) return 0;
            if (!a.hora_inicio) return 1;
            if (!b.hora_inicio) return -1;
            return a.hora_inicio.localeCompare(b.hora_inicio);
        }));
    }, [selectedDate, appointments]);

    useEffect(() => {
        const dates = new Set(appointments.map((apt) => dayjs(apt.data_agendamento).format("YYYY-MM-DD")));
        console.log(dates)
        setDatesWithAppointments(dates);
    }, [appointments]);

    useEffect(() => {
        if (selectMes !== '') loadData();
    }, [selectMes]);

    useEffect(() => {
        const atualMes = selectedDate.format("YYYY-MM");
        setSelectMes(atualMes);
    }, [selectedDate]);

    return (
        <Templete menuActive="agendamentos">
            <SimpleBackdrop open={openLoad} />
            <ModalAgendamento
                open={dialogOpen}
                onClose={() => {
                    setDialogOpen(false);
                    setEditingAppointment(null);
                }}
                onSave={handleSaveAppointment}
                selectedDate={selectedDate}
                onDateSelect={setSelectedDate}
                editingAppointment={editingAppointment}
            />
            <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                    <Calendar
                        selectedDate={selectedDate}
                        onDateSelect={setSelectedDate}
                        datesWithAppointments={datesWithAppointments}
                    />
                </Grid>
                <Grid item xs={12} sm={1}></Grid>
                <Grid item xs={12} sm={7}>
                    <ListEvents
                        selectedDate={selectedDate}
                        appointments={filteredAppointments}
                        onAddAppointment={onAddAppointment}
                        onEditAppointment={onEditAppointment}
                        onDeleteAppointment={handleDeleteAppointment}
                    />
                </Grid>
            </Grid>
        </Templete>
    );
}